export enum Network {
  Mainnet = 'mainnet',
  Testnet = 'testnet',
}
